import React from "react";
import LegalDocument from "../../features/legal/LegalDocument";

const Privacy = () => {
  return (
    <div className="privacy-page full-bleed">
      <LegalDocument doc="privacy" />
    </div>
  );
};

export default Privacy;
